import React, { lazy } from 'react';
import { FadeIn } from './ui/FadeIn';
export function PatternRevealSection() {
  return <section className="py-24 bg-beige relative overflow-hidden" data-id="element-131">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-132">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-133">
          <div className="w-full lg:w-1/2 order-2 lg:order-1" data-id="element-134">
            <FadeIn direction="right" data-id="element-135">
              <div className="relative rounded-sm overflow-hidden shadow-2xl" data-id="element-136">
                <div className="absolute inset-0 bg-gold/10 mix-blend-overlay z-10" data-id="element-137" />
                <img src="https://cdn.magicpatterns.com/uploads/jspjRTkHy2bLs8D6qc9XiE/ChatGPT_Image_20_mar_2026,_07_57_36_p.m..png" alt="Árbol generacional iluminado mostrando raíces profundas" className="w-full h-auto object-cover aspect-square md:aspect-[4/3] lg:aspect-square" loading="lazy" data-id="element-138" />
              </div>
            </FadeIn>
          </div>

          <div className="w-full lg:w-1/2 order-1 lg:order-2" data-id="element-139">
            <FadeIn data-id="element-140">
              <h2 className="font-heading text-4xl md:text-5xl text-charcoal mb-6 leading-tight" data-id="element-141">
                El dolor que no se sana, <br data-id="element-142" />
                <span className="italic text-terracotta" data-id="element-143">se hereda.</span>
              </h2>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-144">
              <div className="space-y-6 font-body text-lg text-charcoal/80 leading-relaxed" data-id="element-145">
                <p data-id="element-146">
                  La ciencia hoy confirma lo que las tradiciones antiguas
                  siempre supieron: los traumas, miedos y bloqueos no resueltos
                  de nuestros ancestros dejan una huella en nuestro ADN
                  emocional.
                </p>
                <p data-id="element-147">
                  Ese miedo al abandono, esa incapacidad para retener el dinero,
                  o esa tristeza profunda que a veces te invade... muy
                  probablemente <strong data-id="element-148">no comenzaron contigo</strong>.
                </p>
                <p data-id="element-149">
                  Son lealtades invisibles. Contratos inconscientes que firmaste
                  por amor a tu sistema familiar, repitiendo sus historias para
                  pertenecer.
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.4} className="mt-10" data-id="element-150">
              <blockquote className="border-l-2 border-gold pl-6 py-2 italic font-heading text-xl text-charcoal/90" data-id="element-151">
                "Hasta que no hagas consciente lo inconsciente, dirigirá tu vida
                y lo llamarás destino."
                <footer className="text-sm font-body not-italic mt-2 text-charcoal/60" data-id="element-152">
                  — Carl Jung
                </footer>
              </blockquote>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}